import { Button } from '@chakra-ui/react';
import NiceModal from '@ebay/nice-modal-react';
import useWhiteLabelOrganizationUsersQuery from 'hooks/useWhiteLabelOrganizationUsersQuery';
import useWorkshopsQuery from 'hooks/useWorkshopsQuery';
import { useTranslation } from 'react-i18next';

import { LoadingSpinner } from '../../../components/LoadingSpinner';
import AlertModal from '../../../components/modals/AlertModal';
import useDeleteWhiteLabelOrganizationMutation from '../../../hooks/mutations/useDeleteWhiteLabelOrganizationMutation';
import useWhiteLabelOrganizationQuery from '../../../hooks/useWhiteLabelOrganizationQuery';
import { ContentCard } from '../../../layout/ContentCard';

const WhiteLabelOrganizationDeleteCard = (props: { whiteLabelOrganizationId: number }) => {
  const { whiteLabelOrganizationId } = props;
  const { t } = useTranslation();

  const workshopsQuery = useWorkshopsQuery({
    whitelabelOrganizationId: whiteLabelOrganizationId,
  });
  const whiteLabelOrganizationUsersQuery = useWhiteLabelOrganizationUsersQuery();

  const whiteLabelOrganizationQuery = useWhiteLabelOrganizationQuery(whiteLabelOrganizationId);
  const deleteWhiteLabelOrganizationMutation = useDeleteWhiteLabelOrganizationMutation(['Whitelabel Organization']);

  const isDeleteDisabled =
    !(workshopsQuery.data?.data && workshopsQuery.data?.data?.length === 0) ||
    !(whiteLabelOrganizationUsersQuery.data?.data && whiteLabelOrganizationUsersQuery.data?.data?.length === 0);

  if (whiteLabelOrganizationQuery.isLoading || workshopsQuery.isLoading || whiteLabelOrganizationUsersQuery.isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <ContentCard
      minH="fit-content"
      header={t('workshop:lock_workshop.title')}
      contentDescription={t('pages:whitelabel_organizations.organization.danger_zone.description')}
      data-test-id="lock-workshop-card"
      bgColor={'red.200'}
      isLoading={whiteLabelOrganizationQuery.isLoading}
    >
      <Button
        disabled={isDeleteDisabled}
        color={'white'}
        backgroundColor={'red.600'}
        borderColor={'red.600'}
        //@ts-ignore
        sx={{
          _hover: { color: 'red.600', backgroundColor: 'white' },
        }}
        variant="outline"
        onClick={() => {
          NiceModal.show(AlertModal as any, {
            onSubmit: () => deleteWhiteLabelOrganizationMutation.mutate(whiteLabelOrganizationId),
            children: t('pages:whitelabel_organizations.organization.danger_zone.delete.message'),
            redSubmitBttn: true,
            content: {
              header: t('pages:whitelabel_organizations.organization.danger_zone.delete.title'),
              footer: {
                buttons: {
                  cancelCaption: t('common:cancel'),
                  actionCaption: t('common:delete'),
                },
              },
            },
          });
        }}
      >
        {t('common:delete')}
      </Button>
    </ContentCard>
  );
};

export default WhiteLabelOrganizationDeleteCard;
